<template>
  <div>
    <el-form
      ref="zlpfForm"
      :rules="rules"
      label-width="120px"
      :hide-required-asterisk="false"
      :v-model="baseInfo"
    >
      <div class="card">
        <el-row>
          <el-col :span="24" class="label"> {{ baseInfo.courseName }} </el-col>
        </el-row>
        <div class="card_content">
          <div>
            <span>课题编号:</span>
            <span>{{ baseInfo.courseId }}</span>
          </div>
          <div>
            <span>课题负责人:</span>
            <span>{{ baseInfo.courseLeaderName }}</span>
          </div>
          <div>
            <span>开始时间:</span>
            <span>{{ baseInfo.nowDate }}</span>
          </div>
          <div>
            <span>总分:</span>
            <span>{{ count }}</span>
          </div>
          <el-row v-if="user.courseAdmin == 1">
            <el-col :span="12">
              <div>
                <span style="margin-right: 30px">是否管理组录入结果:</span>
                <span>
                  <el-radio-group v-model="isSystemGroup">
                    <el-radio label="1">是 </el-radio>
                    <el-radio label="2">否 </el-radio>
                  </el-radio-group>
                </span>
              </div>
            </el-col>
            <el-col :span="12" v-show="isSystemGroup == 1">
              <div>
                <span style="margin-right: 30px">评审委员:</span>
                <span>
                  <el-select
                    v-model="reviewerId"
                    placeholder="请选择评审委员"
                    size="small"
                    style="width: 200px"
                    class="filter-item"
                    @change="handleChangePw"
                  >
                    <el-option
                      v-for="item in pingweiList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    />
                  </el-select>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="card">
        <el-row>
          <el-col :span="24" class="label"> 评审标准 </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" key="9">
            <div
              class="result_content"
              v-for="item in baseInfo.scoringCriteriaList"
              :key="item.criteriaId"
            >
              <div class="label">
                <span>{{ item.scoreType }}</span>
              </div>
              <div class="text">
                <div>参考指标</div>
                <div v-html="item.reference"></div>
                <div v-html="item.scoreTitle"></div>
                <div v-html="item.scoringCriteria"></div>
              </div>
              <div class="score">
                <div>
                  <span>评分（必填）</span>
                  <span>
                    <el-input-number
                      :min="0"
                      :max="+item.scoreMax"
                      label="描述文字"
                      v-model="item.adviceValue"
                      @change="handleChangeScore"
                    >
                    </el-input-number>
                  </span>
                </div>
                <div>评委总得分：{{ count }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="card">
        <el-row>
          <el-col :span="24" class="label"
            ><span class="red_label">*</span
            ><span>综合意见(请重点指出需要改进之处)</span>
          </el-col>
          <el-col :span="24">
            <div id="wangEditor_jxps_form"></div>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>
<script>
import wangEditor from "wangeditor";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import {
  getZlpflistReviewer,
  getQualityScoreReviewByReviewer,
  insertQualityScore,
} from "@/api/course.js";
export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  props: ["mxParams"],
  name: "",
  data() {
    return {
      addDialog: false,
      editDialog: false,
      baseInfo: {},
      height: 500,
      rules: {},
      pingweiList: [],
      reviewerId: null,
      isSystemGroup: "1",
      feedback: null,
      reviewId: null,
      editorList: [],
      editorDataList: [],
      count: 0,
      less80: true,
      editor: null,
      loading: false,
    };
  },
  created() {
    // this.baseInfo = this.mxParams;
    const { id, group } = this.mxParams;
    let step;
    if (group == 1 || group == 3) {
      step = 15;
      if (group == 1) {
        reviewTimes = "2";
      }
    } else {
      step = 6;
    }
    this.isSystemGroup = this.user.courseAdmin == 1 ? "1" : "2";
    getZlpflistReviewer({ courseId: id, courseGroup: group }).then((res) => {
      if (res.code == 0) {
        this.pingweiList = res.data;
      }
    });
    this.getData("");
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.loading) {
        clearInterval(timer);
        let editor = new wangEditor("#wangEditor_jxps_form");
        this.editor = this.editorConfig(editor);
        this.editor.txt.html(this.baseInfo.feedback);
      }
    }, 50);
  },
  methods: {
    getData(reviewerId) {
      getQualityScoreReviewByReviewer({
        courseId: this.mxParams.id,
        reviewerId,
      }).then((res) => {
        if (res.code == 0) {
          this.baseInfo = res.data;
          this.loading = true;
          if (this.baseInfo.courseGroup == 3) {
            this.reviewResult = "2";
          }
          let count = 0;
          for (let i of this.baseInfo.scoringCriteriaList) {
            count = count + Number(i.adviceValue);
          }
          this.editor.txt.html(this.baseInfo.feedback);
          this.count = count;
        }
      });
    },
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中

      editor.create();
      return editor;
    },
    handleChangePw(e) {
      this.reviewerId = e;
      this.getData(e);
    },
    saveForm() {
      if (
        this.isSystemGroup == "1" &&
        !this.reviewerId &&
        this.user.courseAdmin == 1
      ) {
        this.$message.error("请选择评审委员");
        return;
      }
      if (!this.editor.txt.html()) {
        this.$message.error("请输入综合意见");
        return;
      }
      const params = {
        ...this.baseInfo,
        courseId: this.mxParams.id,
        manageGroup: this.isSystemGroup,
        courseGroup: this.mxParams.group,
        reviewerId: this.reviewerId,
        feedback: this.editor.txt.html(),
        total: this.count,
      };

      insertQualityScore(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$emit("getParentForm");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleChangeScore() {
      let count = 0;
      for (let i of this.baseInfo.scoringCriteriaList) {
        count = count + i.adviceValue;
      }
      if (count < 80) {
        this.less80 = true;
        if (this.baseInfo.courseGroup == 3) {
          this.reviewResult = "3";
        }
      } else {
        this.less80 = false;
        if (this.baseInfo.courseGroup == 3) {
          this.reviewResult = "1";
        }
      }
      this.count = count;
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  //   border-bottom: 2px solid #f3f3f3;
  margin-top: 15px;
  .label {
    font-size: 16px;
    font-weight: bold;
    height: 44px;
    line-height: 44px;
    padding-left: 15px;
  }
  .card_content {
    padding: 0 30px;
    > div {
      height: 42px;
      line-height: 42px;
      > span:nth-of-type(1) {
        margin-right: 30px;
      }
    }
  }
}
.card:nth-of-type(1) {
  margin-top: 0;
}
.result_content {
  border: 1px solid #ddd;
  line-height: 32px;
  .label {
    line-height: 42px;
    font-size: 16px;
    background-color: #f3f3f3;
    padding-left: 15px;
  }
  .text {
    padding: 15px;
  }
}
.red_label {
  color: #ff0000;
  margin-right: 5px;
}
.score {
  padding: 15px;
  border-top: 1px solid #ddd;
  display: flex;
  > div {
    margin-right: 15px;
    line-height: 40px;
  }
}
</style>